import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { rpcResult } from '@tomatic/supabase'
import { supabase } from '@/lib/supabase'
import { useUserOrganization } from '@/hooks/useUserOrganization'

interface ResetResult {
  success: boolean
  order_id: number
  old_status: string
  new_status: string
  old_change_source: string
  deliveries_deleted: number
  delivery_lines_deleted: number
  reason: string
}

export function useResetOrderStatus() {
  const { data: org } = useUserOrganization()
  const orgId = org?.organization_id
  const qc = useQueryClient()

  return useMutation({
    mutationFn: async ({ orderId, reason }: { orderId: number; reason: string }) => {
      if (!orgId) throw new Error('No active organization')
      const { data, error } = await supabase
        .schema('admin')
        .rpc('reset_order_status', {
          p_org_id: orgId,
          p_order_id: orderId,
          p_reason: reason,
        })
      if (error) throw error
      return rpcResult<ResetResult>(data)
    },
    onSuccess: (_data, { orderId }) => {
      qc.invalidateQueries({ queryKey: ['dashboard-table-orders'] })
      // Totalene har staleTime: Infinity, så uten dette blir et hentet tall
      // stående og beskriver mengden slik den var før tilbakestillingen.
      qc.invalidateQueries({ queryKey: ['dashboard-table-totals'] })
      qc.invalidateQueries({ queryKey: ['dashboard-order-detail', orderId] })
      qc.invalidateQueries({ queryKey: ['dashboard-order-events', orderId] })
      toast.success('Ordren er tilbakestilt til importert')
    },
    onError: (err: Error) => {
      toast.error(err.message)
    },
  })
}
